import classNames from 'classnames';
import React from 'react';
import { ProductType } from 'types/product';

import styles from './soldBy.module.scss';

type Props = {
  data: ProductType;
  className?: string;
  isHorizontal?: boolean;
};

export default function SoldBy(props: Props) {
  const { data, className, isHorizontal = false } = props;
  const { delivery_desc } = data?.vender_info_view || {};

  if (data?.biz_type !== 'seller') return null;

  return (
    <div
      onClick={e => e.stopPropagation()}
      className={classNames(styles.soldBy, { [styles.isHorizontal]: isHorizontal }, className)}
      dangerouslySetInnerHTML={{ __html: delivery_desc }}></div>
  );
}
